<div class="container">
  <div class="row">
    <div class="col-lg-7 col-12 mt-4">
      <h4 class="text-black fw-bold font-size-18">{{ 'cart.itemsSummary' | translate }}</h4>
      <div class="mb-4 mt-4">
        <fgbcl-cart-item [isCheckoutPage]="true"></fgbcl-cart-item>
      </div>
      <button class="btn text-primary fw-bold ps-0 go-back-btn" (click)="goBack()">
        <span class="font-size-14 text-go-back">{{ 'cart.goBack' | translate }}</span>
      </button>
    </div>
    <div class="col-lg-5 col-12 mt-4">
      <!--member details address-->
      <div class="container address-container py-2 mb-3" [ngClass]="{ 'd-none': editingMemberAddress }">
        <div class="position-relative rounded p-2">
          <div class="d-flex justify-content-between">
            <h4 class="text-black font-size-14">Billing address</h4>
            <h4 class="cursor-pointer font-size-14" (click)="editMemberAddress()">
              {{ 'billing.address.edit' | translate }}
            </h4>
          </div>
          <div class="row">
            <div class="col-10">
              <span *ngIf="memberDetail$ | async as member" class="font-size-14 mb-0 d-flex text-black">
                <div>{{ member.Street }},&nbsp;</div>
                <div>{{ member.Town }},&nbsp;</div>
                <div>{{ member.County }},&nbsp;</div>
                <div>{{ member.Country }},&nbsp;</div>
                <div>{{ member.PostCode }},&nbsp;</div>
                <div>{{ member.HomeNumber }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--EO member details address view-->

      <!-- EDIT MEMBER DETAILS ADDRESS FORM -->
      <ng-container *ngIf="editingMemberAddress">
        <div class="container address-container mb-3">
          <div class="position-relative p-2">
            <div class="d-flex justify-content-between">
              <h4 class="text-black font-size-14 pt-2 mb-3">Address</h4>
              <a
                (click)="clearAddressForm(memberAddressForm)"
                class="text-primary heading-text-one mb-1 pt-2 font-size-14 cursor-pointer fw-bold"
                >Clear Form</a
              >
            </div>

            <form [formGroup]="memberAddressForm" class="font-size-12">
              <!--Street-->
              <div class="form-group form-floating">
                <input
                  id="Street"
                  class="form-control"
                  name="Street"
                  type="text"
                  formControlName="Street"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Street.errors,
                  }"
                  required
                />
                <label for="Street">
                  <span>Street</span>
                </label>
                <div class="invalid-feedback">Please enter a valid street.</div>
              </div>
              <!--City-->
              <div class="form-group form-floating my-2">
                <input
                  id="Town"
                  class="form-control"
                  name="Town"
                  type="text"
                  formControlName="Town"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Town.errors,
                  }"
                  required
                />
                <label for="Town">
                  <span>City</span>
                </label>
                <div class="invalid-feedback">Please enter a valid city.</div>
              </div>
              <!--Country and region-->
              <fgbcl-country-and-regions
                [SeparateRow]="true"
                [Form]="memberAddressForm"
                [HasSubmitted]="hasSubmittedMemberAddress"
              ></fgbcl-country-and-regions>
              <!--Zip code-->
              <div class="form-group form-floating">
                <input
                  id="Postcode"
                  class="form-control"
                  name="Postcode"
                  type="text"
                  formControlName="PostCode"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.PostCode.errors,
                  }"
                  required
                />
                <label for="Postcode">
                  <span>Zip Code</span>
                </label>
                <div class="invalid-feedback">Please enter a valid zip code.</div>
              </div>
              <!--Phone-->
              <div class="form-group form-floating mt-2">
                <input
                  id="HomeNumber"
                  class="form-control"
                  name="HomeNumber"
                  type="text"
                  formControlName="HomeNumber"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.HomeNumber.errors,
                  }"
                  required
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  minlength="8"
                  maxlength="11"
                />
                <label for="Country">
                  <span>Phone Number</span>
                </label>
                <div class="invalid-feedback">Please enter a valid phone number.</div>
              </div>
            </form>

            <div class="d-flex justify-content-end my-2 mt-3 font-size-14">
              <button class="btn btn-primary fw-bold btn-cancel-save me-2 font-size-14" (click)="cancelAndRebuildForm()">
                Cancel
              </button>
              <button class="btn btn-success fw-bold btn-cancel-save font-size-14" (click)="saveMemberDetailAddress()">
                Save
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO edit member details address-->
      <!--summary of items in basket-->
      <ng-container>
        <div class="container address-container p-3">
          <h4 class="text-black fw-bold font-size-14">{{ 'cart.summary' | translate }}</h4>
          <div class="row">
            <div class="col-6 fw-bold font-size-14">
              <span class="fw-normal">{{ 'cart.summary.items' | translate }}</span>
            </div>
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pr-4">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pr-4">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
          <hr class="w-100" />
          <div class="d-flex justify-content-between align-items-center">
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalMerchant' | translate }}</div>
              <div class="d-flex align-items-center">
                <div class="col-6 fw-bold font-size-14 text-end">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="fw-bold font-size-12">{{ 'cart.summary.totalPoint' | translate }}</div>
              <div class="col-6 fw-bold font-size-14 text-end">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="payment-type-container" *ngIf="items$ | async as items">
        <h4 class="text-black fw-bold font-size-14">{{ 'cart.payment' | translate }}</h4>

        <ng-container *ngIf="cardInfor.CardNumber; else noCard">
          <div class="card-infor">
            <p class="font-size-14 mb-0">
              {{ 'cart.card_infor' | translate }}
              <span class="card-number">({{ cardInfor.CardNumber | creditCardNumber: 'true' }})</span>
            </p>
            <ng-container [ngSwitch]="cardInfor.CardType">
              <img
                *ngSwitchCase="1"
                alt="imagedetails"
                class="card-type-image"
                [src]="'payment-icons/mastercard.svg' | contentAssetImage"
              />
              <img
                *ngSwitchCase="2"
                alt="imagedetails"
                class="card-type-image"
                [src]="'payment-icons/amex.svg' | contentAssetImage"
              />
              <img
                *ngSwitchCase="3"
                alt="imagedetails"
                class="card-type-image"
                [src]="'payment-icons/visa.svg' | contentAssetImage"
              />
              <img
                *ngSwitchCase="4"
                alt="imagedetails"
                class="card-type-image"
                [src]="'payment-icons/discover.svg' | contentAssetImage"
              />
              <img
                *ngSwitchCase="5"
                alt="imagedetails"
                class="card-type-image"
                [src]="'payment-icons/jcb.svg' | contentAssetImage"
              />
              <img
                *ngSwitchCase="8"
                alt="imagedetails"
                class="card-type-image"
                [src]="'payment-icons/unionpay.svg' | contentAssetImage"
              /> </ng-container
            ><span class="font-size-14 text-info">Exp:{{ cardInfor.ExpiryDate | date: 'dd/MM' }}</span>
          </div>
          <div class="px-0 mt-2">
            <button
              class="btn btn-success fw-bold mt-2 w-100 paynow-btn d-flex justify-content-center"
              (click)="payNow()"
              [disabled]="
                !memberAddressForm?.valid || !validCheckout || totalPoints > currentBalance || !cardInfor.CardNumber || loading
              "
            >
              {{ statusText }}
              <div *ngIf="loading" class="ms-2">
                <fgbcl-loading></fgbcl-loading>
              </div>
            </button>
            <div class="separator pt-1">
              <span class="mx-2 seperator-text">{{ 'cart.seperator' | translate }}</span>
            </div>
            <button
              (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
              [disabled]="loading || !memberAddressForm?.valid"
              class="btn btn-default fw-bold mt-2 w-100 addcard-btn"
            >
              {{ 'cart.add_new_payment_method' | translate }}
            </button>
          </div>
          <div class="checkbox-container d-flex justify-content-left align-items-center">
            <input type="checkbox" [(ngModel)]="saveAsCardToken" [disabled]="loading" />
            <p class="description">{{ 'cart.save_payment_card' | translate }}</p>
          </div>
        </ng-container>
        <ng-template #noCard>
          <button
            class="btn btn-default fw-bold mt-2 w-100 addcard-btn"
            (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
            [disabled]="!memberAddressForm?.valid"
          >
            {{ 'cart.add_new_card' | translate }}
          </button>
          <div class="checkbox-container d-flex justify-content-left align-items-center">
            <input type="checkbox" [(ngModel)]="saveAsCardToken" />
            <p class="description">{{ 'cart.save_payment_card' | translate }}</p>
          </div>
        </ng-template>
      </div>
      <fgbcl-errors></fgbcl-errors>
    </div>
  </div>
</div>
